// src/components/common/PasswordRequirements.tsx
import React, { useMemo } from 'react';
import { validatePassword, PasswordRequirement } from '../../utils/passwordValidator';
import './PasswordRequirements.scss';

interface PasswordRequirementsProps {
  password: string;
  show?: boolean;
  className?: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  show = true,
  className = '',
}) => {
  const validation = useMemo(() => validatePassword(password), [password]);

  if (!show) {
    return null;
  }

  return (
    <div className={`password-requirements ${className}`}>
      <div className="password-requirements__header">
        <span className="password-requirements__title">Password Requirements</span>
        <span className={`password-requirements__strength password-requirements__strength--${validation.strength}`}>
          {validation.strength.charAt(0).toUpperCase() + validation.strength.slice(1)}
        </span>
      </div>
      
      <ul className="password-requirements__list">
        {validation.requirements.map((req: PasswordRequirement, index: number) => (
          <li
            key={index}
            className={`password-requirements__item ${
              req.met ? 'password-requirements__item--met' : ''
            }`}
          >
            <span className="password-requirements__icon">
              {req.met ? '✓' : '○'}
            </span>
            <span className="password-requirements__label">{req.label}</span>
          </li>
        ))}
      </ul>

      {/* Progress bar */}
      <div className="password-requirements__progress">
        <div
          className={`password-requirements__progress-bar password-requirements__progress-bar--${validation.strength}`}
          style={{ width: `${validation.score}%` }}
        />
      </div>
    </div>
  );
};

export default PasswordRequirements;

